import { propsInfo_coleccion } from "../../../models/Colecciones.model";
import { pathImages } from "../../../routes/endpoints";
import Sin_imagen from "../../../../src/assets/images/sin_imagen.png";

export default function Info_coleccion(props: propsInfo_coleccion){    
    return(        
    <>
        <div className="col-12 col-md-6 col-lg-4 text-end px-5">
            {(props.imagen!==null)
                ?<img alt="imagen_colección" src={`${pathImages}${props.imagen}`} className="img-fluid"/>
                :<img alt="imagen_colección" src={`${Sin_imagen}`} className="img-fluid"/>}
        </div>
        <div className="col-12 col-md-6 col-lg-8 text-start d-flex align-items-center" >                    
            <div>
                <h1 dangerouslySetInnerHTML={{__html: `${props.titulo}` }}></h1>
                <p dangerouslySetInnerHTML={{__html: `${props.descripcion}` }}/>
            </div>
        </div>
    </>
    );
}


